import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Array of hero images - add your images to /public/heroimages/ folder
const HERO_IMAGES = [
  '/heroimages/image1.jpg',
  '/heroimages/image2.jpg',
  '/heroimages/image3.jpg',
  '/heroimages/image4.jpg',
  '/heroimages/image5.jpg',
  '/heroimages/image6.jpg',
  '/heroimages/image7.jpg',
  '/heroimages/image8.jpg',
  '/heroimages/image9.jpg',
  '/heroimages/image10.jpg',
  '/heroimages/image11.jpg',
  '/heroimages/image12.jpg',
];

const Hero: React.FC = () => {
  const { t } = useTranslation();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    // Rotate images every 5 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex(prevIndex => (prevIndex + 1) % HERO_IMAGES.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative flex flex-col lg:flex-row border-black border-b-[3px]">
      {/* Left Text Block */}
      <div className="flex-1 p-6 md:p-12 flex flex-col justify-between bg-white lg:border-r-[3px] border-black">
        <div>
          <div className="text-[10px] md:text-xs font-typewriter mb-4 uppercase tracking-widest text-gray-500">
            {t('hero.reference')}
          </div>
          <p className="text-5xl md:text-7xl lg:text-8xl font-black leading-[0.85] tracking-tighter uppercase mb-8" aria-hidden="true">
            {t('hero.country')}: <span className="text-gray-300">{t('hero.dissolved')}</span>
            <br />
            {t('hero.spirit')}: <span className="text-[#C41E3A]">{t('hero.eternal')}</span>
          </p>
          <h1 className="text-base md:text-lg font-bold uppercase tracking-tight text-gray-700 mb-4">
            The Official Archive for those Born in Yugoslavia
          </h1>
        </div>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-xs font-typewriter text-sm leading-tight uppercase">
            {t('hero.description')}
          </div>
          <div className="border-[3px] border-[#C41E3A] p-4 text-[#C41E3A] font-black text-center md:text-right transform rotate-2">
            <div className="text-xs uppercase leading-none mb-1">{t('hero.authenticatedOn')}</div>
            <div className="text-2xl leading-none">{t('hero.authenticatedDate')}</div>
          </div>
        </div>
      </div>

      {/* Right Visual Block */}
      <div className="flex-1 h-[400px] lg:min-h-[600px] overflow-hidden relative group bg-black">
        {/* Rotating Hero Images */}
        <img
          src={HERO_IMAGES[currentImageIndex]}
          alt={`Yugoslavian Archive Image ${currentImageIndex + 1}`}
          className="w-full h-full object-cover filter grayscale contrast-150 brightness-50 transition-all duration-1000 group-hover:scale-105 group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-black/20 mix-blend-multiply grainy-overlay"></div>
        <div className="scanline"></div>

        {/* Image Counter Indicator */}
        <div className="absolute top-6 right-6 z-30 bg-black text-white px-2 py-1 text-[10px] font-bold uppercase">
          {String(currentImageIndex + 1).padStart(2, '0')}/
          {String(HERO_IMAGES.length).padStart(2, '0')}
        </div>

        <div className="absolute bottom-6 right-6 z-30">
          <div className="bg-[#F0F0F0] border-2 border-black p-2 flex flex-col gap-1">
            <div className="w-12 h-1 bg-black"></div>
            <div className="w-8 h-1 bg-black"></div>
            <div className="w-10 h-1 bg-black"></div>
          </div>
        </div>

        <div className="absolute top-6 left-6 z-30 text-white text-[10px] font-bold uppercase tracking-widest bg-black px-2 py-1">
          {t('hero.sceneLabel')}
        </div>

        {/* Barcode graphic */}
        <div className="absolute bottom-6 left-6 z-30 flex gap-0.5 opacity-40">
          {[2, 4, 1, 3, 2, 6, 1, 2, 5].map((h, i) => (
            <div key={i} className="bg-white w-1" style={{ height: `${h * 4}px` }}></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
